/**
 *
 */
export { Video as VideoPopup } from './components/Video'
